class FillStaticPdf {
  static init() {
    // Hide the preview (it's a PDF file)
    document.querySelector('.document-preview-wrapper').style.display = 'none';
    // Hide the Print button (Download only)
    document.getElementById('printButton').style.display = 'none';

    // Custom Save and Export to fill in a PDF
    const saveAndExportPDF = () => {
      document.querySelector('#instructionPane h1').textContent = 'Compiling Your PDF Document...';
      document.querySelector('#instructionPane .modal-footer').style.display = 'none';

      const pane = document.querySelector('#instructionPane');
      const paneClasses = pane.classList;

      pane.style.display = 'block';
      paneClasses.remove('hide');
      paneClasses.add('in');

      setTimeout(() => {
        pane.style.display = 'none';
        paneClasses.remove('in');
      }, 2500);


      // Save before triggering the export
      const successAction = () => {
        document.location = `/_api/fillAndExportPDFFromSession.php${document.location.search}`;
      };

      window.SessionManager.save(successAction);
    };

    // Fill and export PDF and trigger auto-download
    const button = document.querySelector('.export-button-preview');
    button.href = '#';
    button.removeAttribute('onclick');
    button.addEventListener('click', saveAndExportPDF);

    // Override the save button in the last section to trigger the export
    const exportOnLastSection = () => {
      const numberOfSections = window.ReactCompatibility.getStaticBuilderSectionKeys();
      // Check if we're on the last section
      if (window.Wizard.interface.getCurrentStep() + 1 >= numberOfSections) {
        const saveButton = document.getElementsByClassName('saveButton')[0];
        saveButton.removeAttribute('onclick');
        saveButton.addEventListener('click', saveAndExportPDF);
      }
    };

    // Execute on every section load
    window.ReactCompatibility.addStaticBuilderOnSectionLoadAction(exportOnLastSection);

    // Reload our current step to execute our load action
    window.ReactCompatibility.loadStaticBuilderSection(
      window.ReactCompatibility.getStaticBuilderCurrentStep(),
    );

    // Show the drawer with the sections
    document.querySelector('.builder-toolbar-arrow-wrapper').classList.remove('active-arrow');
    document.getElementById('sectionProgress').className = 'section-progress-wrapper navbar-opened';
    const nav = document.querySelector('.builder-nav');
    nav.classList.remove('collapsed');
    nav.style.display = 'block';
    nav.style.right = '0px';
  }
}

module.exports = FillStaticPdf;



// WEBPACK FOOTER //
// ./src-assets/js/fill-static-pdf.js